module.exports = {
      id: "icon-benifits-adguard-protect-usage",
      viewBox: "0 0 40 40",
      url: __webpack_public_path__ + "images/js_src_vue/page_adguard_landing/sprite.dab809d9.svg#icon-benifits-adguard-protect-usage",
      toString: function () {
        return this.url;
      }
    }